var path = '/templates/projects.settings/other/breadcrumb.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.other.breadcrumb.breadcrumbs' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.other.breadcrumb.description' | translate }}</p><section><zc-breadcrumb-selector project-id=project.id></zc-breadcrumb-selector></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.settings/other/breadcrumb.html
// module id = 1566
// module chunks = 0